import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import {
  TUTORIAL_VIDEOS_LOADER,
  TutorialVideosEntity,
  TutorialVideosFacade,
} from 'gb-dashboard/staff/data-access-tutorial-videos'
import { PendingChangesService } from 'libs/gb-dashboard/shared/utils/src/lib/gb-pending-changes/gb-pending-changes.service'
import * as TutorialVideosActions from 'libs/gb-dashboard/staff/data-access-tutorial-videos/src/lib/+state/tutorial-videos.actions'

@UntilDestroy()
@Component({
  selector: 'gb-add-edit-tutorial-video',
  templateUrl: './gb-add-edit-tutorial-video.component.html',
  styleUrls: ['./gb-add-edit-tutorial-video.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbAddEditTutorialVideoComponent implements OnInit, OnDestroy {
  selectedTutorialVideo$ = this.tutorialVideosFacade.selectedTutorialVideos$
  editCreateLoaded$ = this.tutorialVideosFacade.editCreateLoaded$

  editTutorialVideoFormFields = {
    uuid: new FormControl(''),
    target: new FormControl('', Validators.required),
    video_url: new FormControl('', Validators.required),
    title: new FormControl('', Validators.required),
  }
  editTutorialVideoForm = new FormGroup(this.editTutorialVideoFormFields)
  isEditMode = false

  get target() {
    return this.editTutorialVideoForm.get('target') as FormControl
  }

  get video_url() {
    return this.editTutorialVideoForm.get('video_url') as FormControl
  }

  get title() {
    return this.editTutorialVideoForm.get('title') as FormControl
  }

  constructor(
    private tutorialVideosFacade: TutorialVideosFacade,
    private pendingChangesService: PendingChangesService,
  ) {}

  ngOnInit() {
    this.selectedTutorialVideo$.pipe(untilDestroyed(this)).subscribe((selectedTutorialVideo) => {
      if (selectedTutorialVideo) {
        this.isEditMode = true
        this.editTutorialVideoForm.patchValue(selectedTutorialVideo)
      }
    })

    this.pendingChangesService.registerPendingChanges(this.editTutorialVideoForm, this.selectedTutorialVideo$)
  }

  protected readonly TUTORIAL_VIDEOS_LOADER = TUTORIAL_VIDEOS_LOADER

  ngOnDestroy(): void {
    this.pendingChangesService.resetPendingChanges()
  }

  closeDialog() {
    this.pendingChangesService.closeDialogPendingChanges(GbAddEditTutorialVideoComponent)
  }

  submit() {
    this.editTutorialVideoForm.valid ? this.save() : this.editTutorialVideoForm.markAllAsTouched()
  }

  save() {
    if (this.isEditMode)
      this.tutorialVideosFacade.dispatch(
        TutorialVideosActions.updateTutorialVideo({
          tutorialVideo: this.editTutorialVideoForm.value as Partial<TutorialVideosEntity>,
        }),
      )
    else
      this.tutorialVideosFacade.dispatch(
        TutorialVideosActions.addTutorialVideo({
          tutorialVideo: this.editTutorialVideoForm.value as Partial<TutorialVideosEntity>,
        }),
      )
  }
}
